// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';

import PMTApiUser from 'PMT/api/ApiUser';
import Config from 'constants/Config';

import ActionTypes from 'constants/ActionTypes';
import ApiError from 'PMT/entities/ApiError';

import Restaurant from 'PMT/entities/Restaurant';
import Timelapse from 'PMT/entities/Timelapse';

import { ProAccount } from 'PMT/entities/security';

export default class SessionAction {

  static login(username: string, password: string) {
    PMTApiUser.login(
      username,
      password,
      Config.apikey,
      SessionAction.receiveLogin,
      SessionAction.receiveLoginError,
    );
  }

  static receiveLogin(username: string, password: string) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.LOGIN_RESPONSE_SUCCESS,
      username,
      password
    });
  }

  static receiveLoginError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.LOGIN_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  //
  //

  static logout() {
    AppDispatcher.handleServerAction({
      type: ActionTypes.LOGOUT
    });
  }

  //
  // TODO: move
  //

  static receiveRestaurant(restaurant: Restaurant) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESTAURANT_RESPONSE_SUCCESS,
      restaurant
    });
  }

  static receiveRestaurantError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESTAURANT_RESPONSE_FAILURE,
      apiError
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/actions/SessionAction.js